// Depedency Vuejs
import Vue from 'vue'
import router from './mainrouter'
import store from './store'
// import './registerServiceWorker'
import VueCompositionApi from '@vue/composition-api';

// Third Party JS
import VueAuthenticate from 'vue-authenticate'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueHead from 'vue-head'
import VueProgressiveImage from 'vue-progressive-image'
import VCalendar from 'v-calendar'
import Notifications from 'vue-notification'
// import VueGtm from 'vue-gtm'
// import ApolloClient from 'apollo-client';
// import VueApollo from 'vue-apollo';
// import { HttpLink } from 'apollo-link-http';
// import { InMemoryCache } from 'apollo-cache-inmemory';
import * as VueGoogleMaps from 'vue2-google-maps'
import Vuelidate from 'vuelidate'


// Third Party CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'v-calendar/lib/v-calendar.min.css';

// ADX Library
import './lib/filter'
import { googleMapKey } from '@/lib/config'

// Main vue, the reason we put app vue on bottom for overide third party style, js, etc
import App from './App.vue'

import { createProvider } from './vue-apollo'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueCompositionApi);

// Vue.use(VueGtm, {
//   enabled: true,
//   debug: process.env.VUE_APP_DEBUG,
//   vueRouter: router
// })

Vue.use(VueAuthenticate, {
  tokenPath: 'token',
  providers: {
    google: {
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      redirectUri: process.env.VUE_APP_GOOGLE_REDIRECT_URI,
      url: `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_GOOGLE_BACKEND}`
    },
    facebook: {
      clientId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
      redirectUri: process.env.VUE_APP_FACEBOOK_REDIRECT_URI,
      url: `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_FACEBOOK_BACKEND}`
    }
  }
})

Vue.use(VueHead, {
  separator: '-'
})

Vue.use(VCalendar, {
  datePickerTintColor: '#e5e5ea',
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['DD MMM YYYY'],
    dayPopover: 'L',
    data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD']
  }
})
Vue.use(VueProgressiveImage, {
  delay: 2000,
  placeholder: "http://via.placeholder.com/1x1"
})
Vue.use(Notifications)

// const apolloClient = new ApolloClient({
//   link: new HttpLink({
//     uri: 'http://localhost:9000/graphql'
//   }),
//   cache: new InMemoryCache(),
//   connectToDevTools: true
// });

// Vue.use(VueApollo, {
//   apolloClient,
// });

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyBjO6FTUUvlrsAjd5tkjKxrM0Pvs9Gi_wo',
    key: googleMapKey,
    libraries: 'places',
  },

})

Vue.use(Vuelidate)

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
